var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kindful"},[(_vm.loading)?_c('load-mask'):_vm._e(),_vm._v(" "),(!_vm.formId)?_c('div',[_vm._v("No Form ID specified")]):_vm._e(),_vm._v(" "),_c('div',{ref:"kindfulContainer",staticClass:"kindful-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }